import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import './index.css';
import App from './App';
import { TourProvider } from './contexts/TourContext';
import { ThemeProvider } from './contexts/ThemeContext';

const posthogKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';
if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    person_profiles: 'always',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <TourProvider>
        <App />
      </TourProvider>
    </ThemeProvider>
  </React.StrictMode>
);



